// 콜 상담데스크 중앙 상단 상담사 통계 영역 데이터

const state = () => {
  return {
    totalTime: '00:00:00',
    averageTime: '00:00:00',
    waitTime: '00:00:00',
    summaryTime: '00:00:00',
    emptyTime: '00:00:00',
    maxCount: { inBound: 0, outBound: 0 },
    averageCount: { inBound: 0, outBound: 0 },
    myCount: { inBound: 0, outBound: 0 },
    waitingCount: 0
  };
};

const getters = {
  getAgentStatistics: (state) => {
    return {
      totalTime: state.totalTime,
      averageTime: state.averageTime,
      waitTime: state.waitTime,
      summaryTime: state.summaryTime,
      emptyTime: state.emptyTime,
      maxCount: { inBound: state.maxCount.inBound, outBound: state.maxCount.outBound },
      averageCount: { inBound: state.averageCount.inBound, outBound: state.averageCount.outBound },
      myCount: { inBound: state.myCount.inBound, outBound: state.myCount.outBound }
    };
  },
  getTotalTime: (state) => {
    return state.totalTime;
  },
  getAverageTime: (state) => {
    return state.averageTime;
  },
  getWaitTime: (state) => {
    return state.waitTime;
  },
  getSummaryTime: (state) => {
    return state.summaryTime;
  },
  getEmptyTime: (state) => {
    return state.emptyTime;
  },
  getMaxCount: (state) => {
    return state.maxCount;
  },
  getAverageCount: (state) => {
    return state.averageCount;
  },
  getMyCount: (state) => {
    return state.myCount;
  },
  getWaitingCount: (state) => {
    return state.waitingCount;
  }
};

const mutations = {
  setAgentStatistics(state, payload) {
    state = Object.assign(state, payload);
  },
  setWaitingCount(state, payload) {
    state.waitingCount = payload;
  }
};

export default {
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/call/agentStatistics.js